import { NavLink, useParams, useRouteMatch } from "react-router-dom";

interface Ids {
  assignmentId: string;
  classId: string;
  studentId: string;
}
const backUrls = {
  Assignment: (ids: Ids) => `/Assignments/${ids.assignmentId}?${ids.classId ? `class=${ids.classId}` : ``}`,
  Student: (ids: Ids) => `/Class/${ids.classId}/Student/${ids.studentId}`,
};

export const classSubmissionPath = "/Class/:classId/Student/:studentId/Assignment/:assignmentId";
export const assignmentSubmissionPath = "/Assignment/:assignmentId/Class/:classId/Student/:studentId";

const BackButton = () => {
  const params = useParams<Ids>();
  const isStudentPath = !!useRouteMatch(classSubmissionPath);
  const key = isStudentPath ? "Student" : "Assignment";
  return (
    <NavLink className="reportHeader-backButton" to={backUrls[key](params)}>
      Back to {key}
    </NavLink>
  );
};

export default BackButton;
